import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  en: {
    // Header
    home: "Home",
    photobooth: "Photobooth",
    gallery: "Gallery",
    pricing: "Pricing",
    dashboard: "Dashboard",
    credits: "Credits",
    logout: "Logout",
    
    // Hero
    heroTitle: "Transform Into Anyone",
    heroSubtitle: "AI-powered photo magic that turns you into superheroes, celebrities, and more in seconds",
    startNow: "Start Now",
    viewGallery: "View Gallery",
    freeCredits: "5 Free Credits",
    
    // Categories
    all: "All",
    heroes: "Heroes",
    professions: "Professions",
    military: "Military",
    sports: "Sports",
    fantasy: "Fantasy",
    historical: "Historical",
    business: "Business",
    entertainment: "Entertainment",
    cool: "Cool",
    scifi: "Sci-Fi",
    adventure: "Adventure",
    
    // Photobooth
    selectCharacter: "Select Character",
    takePhoto: "Take Photo",
    processing: "Creating your magic...",
    retake: "Retake",
    download: "Download",
    share: "Share",
    tryAnother: "Try Another",
    countdown: "Get Ready!",
    noCredits: "No Credits Left",
    buyCredits: "Buy Credits",
    
    // Pricing
    pricingTitle: "Choose Your Pack",
    pricingSubtitle: "Get more credits and unlock unlimited creativity",
    starterPack: "Starter Pack",
    boostPack: "Boost Pack",
    proPack: "Pro Pack",
    customPack: "Custom Pack",
    mostPopular: "Most Popular",
    buyNow: "Buy Now",
    perCredit: "per credit",
    bonus: "BONUS",
    save: "Save",
    
    // Features
    allCharacters: "Access to all characters",
    noWatermark: "No watermark",
    hdQuality: "HD Quality",
    ultraHd: "Ultra HD Quality",
    instantDelivery: "Instant delivery",
    prioritySupport: "Priority support",
    commercialLicense: "Commercial license",
    customStyles: "Custom styles",
    
    // Dashboard
    myDashboard: "My Dashboard",
    yourCredits: "Your Credits",
    totalGenerations: "Total Generations",
    referralProgram: "Referral Program",
    yourReferralCode: "Your Referral Code",
    copyCode: "Copy Code",
    copied: "Copied!",
    referralExplain: "Share your code and earn 5 credits when friends purchase",
    myGenerations: "My Generations",
    noGenerations: "No generations yet",
    
    // Payment methods
    paymentMethods: "Payment Methods",
    creditCard: "Credit Card",
    debitCard: "Debit Card",
    applePay: "Apple Pay",
    googlePay: "Google Pay",
    paypal: "PayPal",
    cryptocurrency: "Cryptocurrency",
    selectPaymentMethod: "Select Payment Method",
    securePayment: "Secure Payment",
    paymentProcessed: "Payment Processed Successfully",
    paymentFailed: "Payment Failed",
    tryAgain: "Try Again",
    completePurchase: "Complete Purchase",
    processingPayment: "Processing Payment...",
    paymentSuccess: "Payment Successful!",
    creditsAdded: "credits added to your account",
    
    // Footer
    termsOfService: "Terms of Service",
    privacyPolicy: "Privacy Policy",
    contact: "Contact",
    allRightsReserved: "All Rights Reserved"
  },
  he: {
    // Header
    home: "בית",
    photobooth: "צילום",
    gallery: "גלריה",
    pricing: "מחירים",
    dashboard: "אזור אישי",
    credits: "קרדיטים",
    logout: "התנתק",
    
    // Hero
    heroTitle: "הפכו לכל מי שתרצו",
    heroSubtitle: "קסם צילום מבוסס AI שהופך אתכם לגיבורי-על, סלבריטאים ועוד בשניות",
    startNow: "התחל עכשיו",
    viewGallery: "צפה בגלריה",
    freeCredits: "5 קרדיטים חינם",
    
    // Categories
    all: "הכל",
    heroes: "גיבורים",
    professions: "מקצועות",
    military: "צבא",
    sports: "ספורט",
    fantasy: "פנטזיה",
    historical: "היסטורי",
    business: "עסקים",
    entertainment: "בידור",
    cool: "מגניב",
    scifi: "מדע בדיוני",
    adventure: "הרפתקה",
    
    // Photobooth
    selectCharacter: "בחר דמות",
    takePhoto: "צלם תמונה",
    processing: "יוצרים את הקסם שלך...",
    retake: "צלם שוב",
    download: "הורד",
    share: "שתף",
    tryAnother: "נסה דמות אחרת",
    countdown: "התכונן!",
    noCredits: "אין קרדיטים",
    buyCredits: "קנה קרדיטים",
    
    // Pricing
    pricingTitle: "בחר את החבילה שלך",
    pricingSubtitle: "קבל עוד קרדיטים ופתח יצירתיות בלתי מוגבלת",
    starterPack: "חבילת התחלה",
    boostPack: "חבילת חיזוק",
    proPack: "חבילת מקצוען",
    customPack: "חבילה מותאמת",
    mostPopular: "הכי פופולרי",
    buyNow: "קנה עכשיו",
    perCredit: "לקרדיט",
    bonus: "בונוס",
    save: "חסכון",
    
    // Features
    allCharacters: "גישה לכל הדמויות",
    noWatermark: "ללא סימן מים",
    hdQuality: "איכות HD",
    ultraHd: "איכות Ultra HD",
    instantDelivery: "משלוח מיידי",
    prioritySupport: "תמיכה עדיפה",
    commercialLicense: "רישיון מסחרי",
    customStyles: "סגנונות מותאמים אישית",
    
    // Dashboard
    myDashboard: "האזור האישי שלי",
    yourCredits: "הקרדיטים שלך",
    totalGenerations: "סה״כ יצירות",
    referralProgram: "תוכנית הפניות",
    yourReferralCode: "קוד ההפניה שלך",
    copyCode: "העתק קוד",
    copied: "הועתק!",
    referralExplain: "שתף את הקוד וקבל 5 קרדיטים כשחברים קונים",
    myGenerations: "היצירות שלי",
    noGenerations: "אין יצירות עדיין",
    
    // Payment methods
    paymentMethods: "שיטות תשלום",
    creditCard: "כרטיס אשראי",
    debitCard: "כרטיס חיוב",
    applePay: "Apple Pay",
    googlePay: "Google Pay",
    paypal: "PayPal",
    cryptocurrency: "קריפטו",
    selectPaymentMethod: "בחר שיטת תשלום",
    securePayment: "תשלום מאובטח",
    paymentProcessed: "התשלום עובד בהצלחה",
    paymentFailed: "התשלום נכשל",
    tryAgain: "נסה שוב",
    completePurchase: "השלם רכישה",
    processingPayment: "מעבד תשלום...",
    paymentSuccess: "התשלום הצליח!",
    creditsAdded: "קרדיטים נוספו לחשבון שלך",
    
    // Footer
    termsOfService: "תנאי שימוש",
    privacyPolicy: "מדיניות פרטיות",
    contact: "צור קשר",
    allRightsReserved: "כל הזכויות שמורות"
  }
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('he');
  
  const t = (key) => translations[language][key] || key;
  
  const isRTL = language === 'he';
  
  useEffect(() => {
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
    document.documentElement.lang = language;
  }, [language, isRTL]);
  
  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, isRTL }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
